import { Type } from '@angular/core';
import { ReplicationComponent } from './replication.component';

export * from './replication.component';

export const REPLICATION_DIRECTIVES: Type<any>[] = [
  ReplicationComponent
];
